import { createContext } from 'react'
import { AppUIStateAction } from './reducer/types'

export const AppUIStateDispatchContext = createContext<React.Dispatch<AppUIStateAction> | null>(null)

export const AppUIStateDispatchContextProvider = AppUIStateDispatchContext.Provider
